// NOTE: EditArticle내 Shell에서는 EditableText Padding을 0.2로 설정
export const EDITABLE_SHELL_PADDING = "0.2rem";
